import { render, staticRenderFns } from "./OnlyFourNumber.vue?vue&type=template&id=0e14b3de"
import script from "./OnlyFourNumber.vue?vue&type=script&lang=js"
export * from "./OnlyFourNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports